<digital-platform-address-lookup
  [addressLookupPrepop]="addressLookupPrepop"
  [ctaButton]="ctaButton"
  [beforeFormText]="beforeFormText"
  [industryCode]="industryCode"
  [productCategory]="productCategory"
  [reqServicesType]="reqServicesType"
  [richTextHeading]="richTextHeading"
  [showBusinessTypeSelect]="showBusinessTypeSelect"
  [showProductAvailability]="showProductAvailability"
  [stacked]="stacked"
  [defaultAddress]="storedAddress"
  (selectedAddress)="onAddressSelect($event)"
  (selectedBusinesstype)="onBusinessTypeSelect($event)"
  (selectedCustomerType)="onCustomerTypeSelect($event)"
  (submitButtonClicked)="onSubmitButtonClicked()"
  primarySearchKey="addressLine1"
>
</digital-platform-address-lookup>
